import { Site } from '@envato/foundation-types'
import * as React from 'react'

import quickLinksConfig from '../../../config/layout/quickLinks'
import TextLink from '../textLink/textLink'
import ga from '../../../common/utils/ga'

import * as styles from './siteLinks.module.css'

interface ILink {
  url: string
  label: string
  rel?: string
}
interface IProps {
  currentSite: Site
  site: keyof typeof quickLinksConfig
}

const SiteLinks = ({ currentSite, site }: IProps) => {
  const { label, internal_links, cross_site_links } = quickLinksConfig[site]
  const links = currentSite === site ? internal_links : cross_site_links
  const sendGALinkClickEvent = (event: React.MouseEvent | React.TouchEvent) => {
    ga('send', {
      hitType: 'event',
      eventCategory: 'footer quicklinks',
      eventAction: 'click;link',
      eventLabel: event.currentTarget.textContent
    })
  }
  return (
    <ul className={styles.list}>
      <li className={styles.listTitle}>{label}</li>
      {links.map((linkConfig: ILink, key: number) => (
        <li key={key} className={styles.listItem}>
          <TextLink
            href={linkConfig.url}
            className={styles.link}
            rel={linkConfig.rel}
            onClick={sendGALinkClickEvent}
          >
            {linkConfig.label}
          </TextLink>
        </li>
      ))}
    </ul>
  )
}

export default SiteLinks
